/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import {createApp} from 'vue';
import router from "./router/router";
import App from './components/App.vue';
import { createPinia } from "pinia";
import mitt from 'mitt';
import VueMarkdownIt from 'vue3-markdown-it';
import VueApexCharts from 'vue3-apexcharts';


// Check if Vue app is already mounted to prevent conflicts
const el = document.getElementById('app');

// Only skip mounting if there's ACTUALLY a mounted Vue app (not just flags)
const actuallyHasMountedVue = el && (el.__vue_app__ || el._vnode);

if (actuallyHasMountedVue) {
    // Skip mounting if Vue app already exists
} else {

// Check if the page needs Vue Router (i.e. full SPA control) we need this for now until we eventually migrate full portal to Vue Router
const isSpa = el?.dataset.vue === 'spa'

const app = createApp(App)

const pinia = createPinia()
app.use(pinia);

if (isSpa) {
    app.use(router)
}

app.config.globalProperties.emitter = mitt();
app.provide('emitter', app.config.globalProperties.emitter);

// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */

// // const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default);)

// Initializer
app.component('portal-content-and-design-initializer', require('./components/common/PortalContentAndDesignInitializer.vue').default);

// Editable fields components needed for live designer
app.component('editable-text-field', require('./components/partners/portal-editable-fields/EditableTextField.vue').default);
app.component('editable-btn', require('./components/partners/portal-editable-fields/EditableBtn.vue').default);
app.component('editable-social-auth-btn', require('./components/partners/portal-editable-fields/EditableSocialAuthBtn.vue').default);

app.component('btn', require('./elements/Btn.vue').default);
app.component('notification', require('./elements/Notification.vue').default);
app.component('icon', require('./elements/Icon.vue').default);
app.component('header-bar', require('./elements/HeaderBar.vue').default);
app.component('modal', require('./elements/Modal.vue').default);
app.component('modal-upload', require('./elements/ModalUpload.vue').default);
app.component('sidebar-menu', require('./elements/sidebar/SidebarMenu.vue').default);
app.component('tooltip', require('./elements/Tooltip.vue').default);
app.component('field-label', require('./elements/forms/FieldLabel.vue').default);

app.component('options', require('./elements/options/Options.vue').default);
app.component('options-item', require('./elements/options/OptionsItem.vue').default);
app.component('options-toggle', require('./elements/options/OptionsToggle.vue').default);
app.component('options-divider', require('./elements/options/OptionsDivider.vue').default);
app.component('text-field', require('./elements/forms/TextField.vue').default);
app.component('select-field', require('./elements/forms/SelectField.vue').default);
app.component('password', require('./elements/forms/Password.vue').default);
app.component('phone-dial-code-select', require('./elements/forms/PhoneDialCodeSelect.vue').default);
app.component('toggle', require('./elements/forms/Toggle.vue').default);
app.component('radio', require('./elements/forms/Radio.vue').default);
app.component('radio-group', require('./elements/forms/RadioGroup.vue').default);
app.component('radio-group-inline', require('./elements/forms/RadioGroupInline.vue').default);
app.component('radio-group-inline-color', require('./elements/forms/RadioGroupInlineColor.vue').default);
app.component('require-password-change-modal', require('./elements/forms/RequirePasswordChangeModal.vue').default);
app.component('file-upload', require('./elements/forms/FileUpload').default);
app.component('two-factor-auth-enable-modal', require('./../../vendor/remotecompany/accounts/resources/js/TwoFactorAuthEnableModal.vue').default);
app.component('two-factor-auth-disable-modal', require('./../../vendor/remotecompany/accounts/resources/js/TwoFactorAuthDisableModal.vue').default);
app.component('account-profile', require('./components/account-profile/AccountProfile.vue').default);
app.component('hamburger', require('./components/Hamburger.vue').default);
app.component('qr-code', require('./elements/QrCode.vue').default);

// Partners
app.component('social-auth-btn', require('./components/partners/login/social/SocialAuthBtn.vue').default);
app.component('date-range-picker', require('./components/partners/DateRangePicker').default);
app.component('partner-identifier-update', require('./components/partners/IdentifierUpdate').default);
app.component('partner-create-custom-link', require('./components/partners/CreateCustomLink').default);
app.component('partner-update-custom-link', require('./components/partners/UpdateCustomLink').default);
app.component('partner-delete-custom-link', require('./components/partners/DeleteCustomLink').default);
app.component('partner-resources-accordion', require('./components/partners/resources/Accordion').default);
app.component('partner-delete', require('./components/partners/PartnerDelete').default);
app.component('edit-toggle-button', require('./components/partners/Pub/components/EditToggleButton.vue').default);
app.component('live-designer-accordion', require('./components/partners/live-designer/includes/Accordion.vue').default);
app.component('live-designer', require('./components/partners/live-designer/LiveDesigner.vue').default);
app.component('invite-friends-by-email', require('./components/partners/InviteFriendsByEmail.vue').default);
app.component('partner-create-referral', require('./components/partners/referrals/components/ReferralCreate').default);

// Auth app
app.component('partners-auth-app', require('./components/partners/auth/App.vue').default);

// Affiliate pub pages
app.component('app-affiliate', require('./components/partners/Pub/AppAffiliate.vue').default);
app.component('app-referral-portal', require('./components/partners/referral-portal/App/AppReferralPortal.vue').default);
app.component('app-pages', require('./components/partners/Pub/AppPages.vue').default);
app.component('pub-affiliate', require('./components/partners/Pub/PubAffiliate.vue').default);
app.component('pub-referral', require('./components/partners/Pub/AppReferral.vue').default);
app.component('pub-pages', require('./components/partners/Pub/PubPages.vue').default);
app.component('portal-login', require('./components/partners/Pub/Pages/Login/PortalLogin.vue').default);
app.component('sub-account-portal-login', require('./components/partners/Pub/Pages/SubAccountLogin/SubAccountPortalLogin.vue').default);
app.component('sub-account-login-form', require('./components/partners/Pub/Pages/SubAccountLogin/Partial/SubAccountLoginForm.vue').default);
app.component('referral-portal-login', require('./components/partners/referral-portal/pub/Pages/Login/ReferralPortalLogin.vue').default);
app.component('referral-portal-otp-login', require('./components/partners/referral-portal/pub/Pages/Login/ReferralPortalOtpLogin.vue').default);
app.component('referral-portal-register', require('./components/partners/referral-portal/pub/Pages/ReferralPortalRegister.vue').default);
app.component('referral-portal-program', require('./components/partners/referral-portal/pub/Pages/ReferralPortalProgram.vue').default);
app.component('referral-portal-dashboard', require('./components/partners/referral-portal/auth/pages/ReferralPortal/Dashboard/ReferralPortalDashboard.vue').default);
app.component('portal-otp-login', require('./components/partners/Pub/Pages/Login/Otp/PortalOtpLogin.vue').default);
app.component('portal-register', require('./components/partners/Pub/Pages/Register/PortalRegister.vue').default);
app.component('portal-landing', require('./components/partners/Pub/Pages/Landing/PortalLanding.vue').default);
app.component('portal-leads', require('./components/partners/Pub/Pages/Leads/PortalLeads.vue').default);
app.component('portal-password-reset-email', require('./components/partners/Pub/Pages/Passwords/PortalPasswordResetEmail.vue').default);
app.component('portal-password-reset-request', require('./components/partners/Pub/Pages/Passwords/PortalPasswordResetRequest.vue').default);
app.component('sub-account-portal-password-reset-email', require('./components/partners/Pub/Pages/Passwords/SubAccountPortalPasswordResetEmail.vue').default);
app.component('sub-account-portal-password-reset-request', require('./components/partners/Pub/Pages/Passwords/SubAccountPortalPasswordResetRequest.vue').default);
app.component('language-selector', require('./components/partners/Pub/LanguageSelector.vue').default);

// Auth page layouts
app.component('affiliate-layout', require('./components/partners/auth/layouts/AffiliateLayout.vue').default);
app.component('refer-a-friend-layout', require('./components/partners/referral-portal/auth/layouts/ReferAFriendLayout.vue').default);

// Portal landing page resources
app.component('base-resources-builder', require('./components/app/resources-builder/Builder.vue').default);
app.component('draggable-accordion', require('./elements/accordions/DraggableAccordion.vue').default);
app.component('text-editor', require('./elements/TextEditor').default);


// Index pages
app.component('partner-referral-index', require('./components/partners/referrals/ReferralIndex.vue').default);
app.component('partner-leads-index', require('./components/partners/leads/LeadsIndex.vue').default);

app.component('program-lead-logged-partner', require('./components/partners/program_leads/LeadFormLoggedPartner.vue').default);

// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
// */

app.use(VueMarkdownIt);
app.use(VueApexCharts);

// Mount the Vue app
try {
    // If there's already a Vue app mounted, try to unmount it first
    const appElement = document.getElementById('app');
    if (appElement && appElement.__vue_app__) {
        appElement.__vue_app__.unmount();
    }
    
    app.mount("#app");
} catch (error) {
    // If mounting fails, try to force unmount and remount
    try {
        const appElement = document.getElementById('app');
        if (appElement && appElement.__vue_app__) {
            appElement.__vue_app__.unmount();
        }
        // Clear the element completely
        appElement.innerHTML = '';
        app.mount("#app");
    } catch (retryError) {
        // Silent fail on retry
    }
}

} // End of Vue app initialization guard
